import * as types from './actionTypes';
import trainingAPI from '../services/trainingAPI';
import trainingPartAPI from '../services/trainingPartAPI';
import { toast } from 'react-toastify';
import { toastMessages, toastOptions } from '../config/toastifyConfig';

// Helper function to create actions
function createAction(type, payload = {}) {
  return { type, ...payload };
}

// Centralized error handler
function handleError(error, message) {
  toast.error(message || "Wystąpił błąd.", toastOptions); // Use toast.error
  console.error(error); // Log error details
  throw error;
}

// Input validation
function validateId(id) {
  if (!id || typeof id !== "number") {
    throw new Error("Invalid ID provided");
  }
}

// Action creators
export function loadTrainingsSuccess(trainingList) {
  return createAction(types.LOAD_TRAININGS_SUCCESS, { trainingList });
}

export function loadSingleTrainingSuccess(training) {
  return createAction(types.LOAD_SINGLE_TRAINING_SUCCESS, { training });
}

export function addTrainingSuccess(training) {
  return createAction(types.ADD_TRAINING_SUCCESS, { training });
}

export function saveTrainingSuccess(training) {
  return createAction(types.SAVE_TRAINING_SUCCESS, { training });
}

export function updateTrainingSuccess(training) {
  return createAction(types.UPDATE_TRAINING_SUCCESS, { training });
}

export function deleteTrainingsSuccess(id) {
  return createAction(types.DELETE_TRAINING_SUCCESS, { id });
}

// Thunk actions
export function loadSingleTrainingById(trainingId) {
  return async (dispatch) => {
    validateId(trainingId);
    try {
      const training = await trainingAPI.getById(trainingId);
      dispatch(loadSingleTrainingSuccess(training));
    } catch (error) {
      handleError(error, toastMessages.trainingLoadError);
    }
  };
}

export function loadTrainingsForUser(userId) {
  return async (dispatch) => {
    validateId(userId);
    try {
      const trainingList = await trainingAPI.getByUserId(userId);
      dispatch(loadTrainingsSuccess(trainingList));
    } catch (error) {
      handleError(error, toastMessages.trainingLoadError);
    }
  };
}

export function loadTrainingsForDateRangeAndUser(userId, startDate, endDate) {
  return async (dispatch) => {
    validateId(userId);
    try {
      const trainingList = await trainingAPI.getByDateForRangeAndUser(userId, startDate, endDate);
      dispatch(loadTrainingsSuccess(trainingList));
    } catch (error) {
      handleError(error, toastMessages.trainingLoadError);
    }
  };
}

export function addTraining(trainingToSave) {
  return async (dispatch) => {
    try {
      const training = await trainingAPI.add(trainingToSave);
      toast.success(toastMessages.trainingSaved, toastOptions); // Updated to toast.success
      dispatch(addTrainingSuccess(training));
    } catch (error) {
      handleError(error, toastMessages.trainingSaveError); // Updated error handling
    }
  };
}

export function saveTrainingDB(trainingToSave) {
  console.log("saveTrainingDB:" + JSON.stringify(trainingToSave));
  return async (dispatch) => {
    try {
      // Remove deleted parts and process
      trainingToSave.trainingParts = trainingToSave.trainingParts?.filter((part) => {
        if (part.isDeleted) {
          trainingPartAPI.deleteTrainingPart(part.id);
          return false;
        }
        return true;
      }) || [];

      const updatedTraining = await trainingAPI.update(trainingToSave);
      toast.success(toastMessages.trainingSaved, toastOptions); // Updated success message
      dispatch(saveTrainingSuccess(updatedTraining));
    } catch (error) {
      handleError(error, toastMessages.trainingSaveError); // Updated error handling
    }
  };
}

export function updateTraining(trainingToUpdate) {
  return (dispatch) => {
    dispatch(updateTrainingSuccess(trainingToUpdate));
  };
}

export function deleteTraining(trainingIdToDelete) {
  return async (dispatch) => {
    validateId(trainingIdToDelete);
    try {
      await trainingAPI.deleteById(trainingIdToDelete);
      toast.success(toastMessages.trainingDeleted, toastOptions); // Updated success message
      dispatch(deleteTrainingsSuccess(trainingIdToDelete));
    } catch (error) {
      handleError(error, toastMessages.trainingDeleteError); // Updated error handling
    }
  };
}
